// Intersection observer for animating block transitions
import map from 'lodash/fp/map';

let lastScrollY = window.scrollY;

export function animations() {
  const blocks = document.querySelectorAll('.block'); // Keep visible behavior
  const ctaBlocks = document.querySelectorAll('.block--call-to-action');

  const observer = new IntersectionObserver((entries) => {
    map((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible'); // Keep existing behavior
      }
    }, entries);
  }, { threshold: 0.33 });

  map(block => observer.observe(block), blocks);

  // Function to handle the zoom effect as you scroll
  function handleScroll() {
    ctaBlocks.forEach((block) => {

      // Grab the image, skip if it isn't present
      const img = block.querySelector('img');
      if (!img) return;

      const rect = block.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const scrollProgress = Math.min(Math.max(1 - rect.top / windowHeight, 0), 1);
      const scaleValue = 1 + (scrollProgress * 0.04);

      img.style.transform = `scale(${scaleValue})`;
    });
  }

  // Attach scroll event listener
  window.addEventListener('scroll', handleScroll);
}
